import React, { Component } from "react";
import AsideRightMenu from "../Dashboard/AsideRightMenu";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import {
  editProfileFormData,
  updateCompanyProfile,
  uploadEmpHeader,
  uploadEmplogo,
} from "../../action/profile";
import constant from "../../constant";
import { onChange, setOptions, validateForm } from "../../utils";
import Swal from "sweetalert2";
import { Link, withRouter } from "react-router-dom";
import swal from "sweetalert";

class EditProfile extends Component {
  constructor(props) {
    super(props);
    const details = props.details;
    this.state = {
      detail: undefined,
      primaryEmail: {
        name: "primaryEmail",
        value: details ? details.EMAIL : "",
        options: [],
        error: [],
        isRequired: true,
      },
      secondryEmail: {
        name: "secondryEmail",
        value: details ? details.SECONDARY_EMAIL : "",
        options: [],
        error: [],
        isRequired: false,
      },
      role: {
        name: "role",
        value: details ? details.EMPLOYER_ROLE_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      mobile: {
        name: "mobile",
        value: details ? details.MOBILE : "",
        options: [],
        error: [],
        isRequired: true,
      },
      location: {
        name: "location",
        value: details ? details.LOCATION : "",
        options: [],
        error: [],
        isRequired: false,
      },
      companyName: {
        name: "companyName",
        value: details ? details.COMPANY_NAME : "",
        options: [],
        error: [],
        isRequired: true,
      },
      companyType: {
        name: "companyType",
        value: details ? details.COMPANY_TYPE_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      industryType: {
        name: "industryType",
        value: details ? details.EMPLOYER_INDUSTRY_ID : "",
        options: [],
        error: [],
        isRequired: true,
      },
      contactPerson: {
        name: "contactPerson",
        value: details ? details.CONTACT_PERSON : "",
        options: [],
        error: [],
        isRequired: true,
      },
      contactPersonDesignation: {
        name: "contactPersonDesignation",
        value: details ? details.CONTACT_PERSON_DESIGNATION : "",
        options: [],
        isRequired: false,
      },
      websiteUrl: {
        name: "websiteUrl",
        value: details ? details.WEBSITE : "",
        options: [],
        error: [],
        isRequired: true,
      },
      phone1: {
        name: "phone1",
        value: details ? details.PHONE_1 : "",
        options: [],
        error: [],
        isRequired: false,
      },
      phone2: {
        name: "phone2",
        value: details ? details.PHONE_2 : "",
        options: [],
        error: [],
        isRequired: false,
      },
      faxNumber: {
        name: "faxNumber",
        value: details ? details.FAX_NUMBER : "",
        options: [],
        error: [],
        isRequired: false,
      },
      companyLogo: {
        name: "companyLogo",
        value: details ? details.COMPANY_LOGO : "",
        options: [],
        error: [],
        isRequired: true,
      },
      companyHeaderBackground: {
        name: "companyHeaderBackground",
        value: details ? details.COMPANY_HEADER_BACKGROUND : "",
        options: [],
        error: [],
        isRequired: false,
      },
      facebookPageUrl: {
        name: "facebookPageUrl",
        value: details ? details.FB_URL : "",
        options: [],
        error: [],
        isRequired: false,
      },
      linkedinProfileUrl: {
        name: "linkedinProfileUrl",
        value: details ? details.LINKEDIN_URL : "",
        options: [],
        error: [],
        isRequired: false,
      },
      twitterUrl: {
        name: "twitterUrl",
        value: details ? details.TWITTER_URL : "",
        error: [],
        isRequired: false,
      },
      companySize: {
        name: "companySize",
        value: details ? details.COMPANY_SIZE : "",
        options: [],
        error: [],
        isRequired: true,
      },
      founded: {
        name: "founded",
        value: details ? details.FOUNDED : "",
        options: [],
        error: [],
        isRequired: false,
      },
      headquarters: {
        name: "headquarters",
        value: details ? details.HEADQUARTERS : "",
        options: [],
        error: [],
        isRequired: false,
      },
      aboutCompany: {
        name: "aboutCompany",
        value: details ? details.ABOUT_COMPANY : "",
        options: [],
        error: [],
        isRequired: false,
      },
      pinCode: {
        name: "pinCode",
        value: details ? details.PINCODE : "",
        options: [],
        error: [],
        isRequired: true,
      },
      companyCategory: {
        name: "companyCategory",
        value: details ? details.EMPLOYER_CATEGORY : "",
        options: [],
        error: [],
        isRequired: true,
      },
    };
  }
  componentDidMount() {
    document.title = constant.title.EditProfile;

    editProfileFormData().then((res) => {
      if (res.status) {
        setOptions(this, this.state.role.name, res.result.list1);
        setOptions(this, this.state.companyType.name, res.result.list2);
        setOptions(this, this.state.industryType.name, res.result.list);
      }
    });
  }

  onPictureUpload = (e) => {
    e.preventDefault();
    let model = new FormData();
    let file = e.target.files[0]
    const imageMimeType = /image\/(png|jpg|jpeg)/i;
    if (!file.type.match(imageMimeType)) {
      let companyLogo = this.state.companyLogo
      companyLogo.value = ""
      swal({
        icon: "error",
        text: "Please upload PNG / JPG / JPEG only",
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
      this.setState({ companyLogo: companyLogo });
    } else {
      model.append("file", e.target.files[0]);
      uploadEmplogo(model).then((res) => {
        if (res.status) {
          console.log("SUCCESS");
          onChange(this, this.state.companyLogo.name, res.result.fileName);
        } else {
          alert(res.error);
        }
      });
    }
  };

  onHeaderUpload = (e) => {
    e.preventDefault();
    let model = new FormData();
    let file = e.target.files[0]
    const imageMimeType = /image\/(png|jpg|jpeg)/i;
    if (!file.type.match(imageMimeType)) {
      let companyHeaderBackground = this.state.companyHeaderBackground
      companyHeaderBackground.value = ""
      swal({
        icon: "error",
        text: "Please upload PNG / JPG / JPEG only",
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
      this.setState({ companyHeaderBackground: companyHeaderBackground });
      return;
    } else {
      model.append("file", e.target.files[0]);
      uploadEmpHeader(model).then((res) => {
        if (res.status) {
          console.log("SUCCESS");
          onChange(
            this,
            this.state.companyHeaderBackground.name,
            res.result.fileName
          );
        } else {
          alert(res.error);
        }
      });
    };
  };

  onSubmit = (e) => {
    e.preventDefault();
    let status = validateForm(this);
    if (status) {
      const {
        primaryEmail,
        secondryEmail,
        role,
        mobile,
        location,
        companyName,
        companyType,
        industryType,
        contactPerson,
        websiteUrl,
        phone1,
        phone2,
        companyLogo,
        companyHeaderBackground,
        facebookPageUrl,
        linkedinProfileUrl,
        twitterUrl,
        companySize,
        founded,
        headquarters,
        aboutCompany,
        contactPersonDesignation,
        faxNumber,
        pinCode,
        companyCategory,
      } = this.state;
      const model = {
        primaryEmail: primaryEmail.value,
        SECONDARY_EMAIL: secondryEmail.value,
        EMPLOYER_ROLE_ID: role.value,
        mobile: formatPhoneNumberIntl(mobile.value),
        LOCATION: location.value,
        companyName: companyName.value,
        // companyType: companyType.value,
        EMPLOYER_INDUSTRY_ID: industryType.value,
        CONTACT_PERSON: contactPerson.value,
        WEBSITE: websiteUrl.value,
        PHONE_1: phone1.value,
        PHONE_2: phone2.value,
        COMPANY_LOGO: companyLogo.value,
        COMPANY_HEADER_BACKGROUND: companyHeaderBackground.value,
        FB_URL: facebookPageUrl.value,
        LINKEDIN_URL: linkedinProfileUrl.value,
        TWITTER_URL: twitterUrl.value,
        COMPANY_SIZE: companySize.value,
        FOUNDED: founded.value,
        HEADQUARTERS: headquarters.value,
        ABOUT_COMPANY: aboutCompany.value,
        CONTACT_PERSON_DESIGNATION: contactPersonDesignation.value,
        FAX_NUMBER: faxNumber.value,
        PINCODE: pinCode.value,
        EMPLOYER_CATEGORY: companyCategory.value,
        COMPANY_TYPE_ID: companyType.value,
        MOBILE: mobile.value,
      };
      updateCompanyProfile(model).then((res) => {
        if (res.status) {
          Swal.fire({
            icon: "success",
            text: res.result.message,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.props.history.push(constant.component.Dashboard.url);
        } else {
          Swal.fire({
            icon: "error",
            text: res.error,
            timer: 1500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      });
    }
  };

  onChange = (e) => {
    const { name, value } = e.target;
    onChange(this, name, value);
  };

  render() {
    const {
      primaryEmail,
      secondryEmail,
      role,
      mobile,
      location,
      companyName,
      companyType,
      industryType,
      contactPerson,
      websiteUrl,
      phone1,
      phone2,
      companyLogo,
      companyHeaderBackground,
      facebookPageUrl,
      linkedinProfileUrl,
      twitterUrl,
      companySize,
      founded,
      headquarters,
      aboutCompany,
      contactPersonDesignation,
      faxNumber,
      pinCode,
      companyCategory,
    } = this.state;
    const { details } = this.props;
    return (
      <React.Fragment>
        <section className="pricing-area edit-profile-section padding-top-100px padding-bottom-80px">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <AsideRightMenu />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center">
                      {/* <div className="section-heading">
                                        <h2 className="sec__title">Post a Job</h2>
                                    </div> */}
                      <ul className="list-items d-flex align-items-center">
                        <li className="active__list-item">
                          <Link to={constant.component.Dashboard.url} className="text-secondary">
                            Home
                          </Link>
                        </li>
                        <li className="active__list-item text-secondary">
                          <Link to={constant.component.Dashboard.url} className="text-secondary">
                            Dashboard
                          </Link>

                        </li>
                        <li className=" text-secondary">Edit Profile</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="billing-form-item mb-0">
                      <div
                        className="billing-title-wrap"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <h3 className="widget-title pb-0">Edit Profile</h3>
                          <div className="title-shape margin-top-5px"></div>
                        </div>
                        <div>
                          <h3 className="widget-title pb-0">
                            <a
                              class="theme-btn border-0 line-height-35"
                              href="/viewProfile"
                            >
                              View Profile
                            </a>
                          </h3>
                        </div>
                      </div>
                      <div className="billing-content">
                        <div className="postjob-form-action">
                          <form onSubmit={this.onSubmit} method="post">
                            <div className="row">
                              {/* <div className="col-lg-6 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">Username <span className='text-danger font-size-16'>*</span></label>
                                                                        <div className="form-group">
                                                                            <input
                                                                                className="form-control"
                                                                                type="text"
                                                                                name="text"
                                                                                placeholder="Mention the designation or role"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Primary Email{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        primaryEmail.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={primaryEmail.name}
                                      value={primaryEmail.value}
                                      onChange={this.onChange}
                                      placeholder="Mention the Primary Email"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Secondary Email{" "}
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={secondryEmail.name}
                                      value={secondryEmail.value}
                                      onChange={this.onChange}
                                      placeholder="Mention the Secondary Email"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Role{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      // className="postjob-select"
                                      className={
                                        role.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }

                                      name={role.name}
                                      value={role.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select Role</option>
                                      {role.options &&
                                        role.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.EMPLOYER_ROLE_ID}
                                            >
                                              {item.EMPLOYER_ROLE}
                                            </option>
                                          );
                                        })}
                                      {/* <option value="1">Recruitment/Placement Consultant</option>
                                                                            <option value="2">Company Recruiter, HR Professional</option>
                                                                            <option value="3">Hiring Manager/Entrepreneur</option>
                                                                            <option value="4">Other</option> */}
                                    </select>
                                  </div>
                                </div>
                              </div>


                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Mobile{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <PhoneInput
                                      className={
                                        mobile.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={mobile.name}
                                      value={mobile.value}
                                      defaultPhone="Telephone"
                                      onChange={(phone) =>
                                        onChange(this, mobile.name, phone)
                                      }
                                      placeholder="Mobile"
                                      maxLength={11}
                                      defaultCountry="IN"

                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">Location</label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        location.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={location.name}
                                      value={location.value}
                                      onChange={this.onChange}
                                      placeholder="Location"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Name{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        companyName.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={companyName.name}
                                      value={companyName.value}
                                      onChange={this.onChange}
                                      placeholder="Company Name"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Category{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        companyCategory.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={companyCategory.name}
                                      value={companyCategory.value}
                                      onChange={this.onChange}
                                    >
                                      <option value="">Select Company Category</option>
                                      <option value="COMPANY">Company</option>
                                      <option value="CONSULTANT">
                                        Consultant
                                      </option>
                                      {/* <option value="6">Foreign MNC</option>
                                                                            <option value="7">Indian MNC</option>
                                                                            <option value="8">Startup</option>
                                                                            <option value="9">Corporate</option> */}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <select
                                      className={
                                        companyType.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name={companyType.name}
                                      value={companyType.value}
                                      onChange={this.onChange}

                                    >
                                      {companyType.error.length > 0 && !companyType.value && <span className='text-danger ml-1'>{companyType.error}</span>}

                                      <option value="">Select Company Type</option>
                                      {companyType.options &&
                                        companyType.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.COMPANY_TYPE_ID}
                                            >
                                              {item.COMPANY_TYPE}
                                            </option>
                                          );
                                        })}
                                      {/* <option value="1">Company</option>
                                                                            <option value="2">Consultant</option>
                                                                            <option value="6">Foreign MNC</option>
                                                                            <option value="7">Indian MNC</option>
                                                                            <option value="8">Startup</option>
                                                                            <option value="9">Corporate</option> */}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Industry Type{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group postjob-select-container">
                                    <select
                                      className={
                                        industryType.error.length > 0
                                          ? "postjob-select is-invalid"
                                          : "postjob-select"
                                      }
                                      name={industryType.name}
                                      value={industryType.value}
                                      onChange={this.onChange}
                                    >
                                      <option>Select Industry Type</option>
                                      {industryType.options &&
                                        industryType.options.map(function (
                                          item,
                                          index
                                        ) {
                                          return (
                                            <option
                                              key={index}
                                              value={item.EMPLOYER_INDUSTRY_ID}
                                            >
                                              {item.INDUSTRY}
                                            </option>
                                          );
                                        })}
                                      {/* <option value="1">Accounting / Finance</option>
                                                                            <option value="2">Advertising / PR / MR / Event Management</option><option value="3">Agriculture </option>
                                                                            <option value="4">Hotels / Restaurants / Airlines / Travel</option><option value="5">Architecture / Interior Design</option>
                                                                            <option value="6">Automobile / Auto Anciliary / Auto Components</option>
                                                                            <option value="7">Pharma / Biotechnology / Clinical Research</option> */}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Contact Person{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        contactPerson.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={contactPerson.name}
                                      value={contactPerson.value}
                                      onChange={this.onChange}
                                      placeholder="Contact Person"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Pin Code{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        pinCode.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={pinCode.name}
                                      value={pinCode.value}
                                      onChange={this.onChange}
                                      placeholder="Pin Code"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Contact Person's Designation
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={contactPersonDesignation.name}
                                      value={contactPersonDesignation.value}
                                      onChange={this.onChange}
                                      placeholder="Contact Person's Designation"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Website URL{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        websiteUrl.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={websiteUrl.name}
                                      value={websiteUrl.value}
                                      onChange={this.onChange}
                                      placeholder="Website URL"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">Phone 1</label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={phone1.name}
                                      value={phone1.value}
                                      onChange={this.onChange}
                                      placeholder=" Enter Phone 1"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">Phone 2</label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={phone2.name}
                                      value={phone2.value}
                                      onChange={this.onChange}
                                      placeholder=" Enter Phone 2"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    FAX Number
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={faxNumber.name}
                                      value={faxNumber.value}
                                      onChange={this.onChange}
                                      placeholder=" Enter FAX Number"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Logo{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        companyLogo.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="file"
                                      name={companyLogo.name}
                                      onChange={this.onPictureUpload}
                                      placeholder="Upload Logo"
                                      accept="image/png, image/jpg, image/jpeg"
                                    />
                                    {details ? (
                                      <a
                                        target="_blank"
                                        href={`${process.env.REACT_APP_BASE_URL}/company/logo/${details.COMPANY_LOGO}`}
                                      >
                                        {details.COMPANY_LOGO}
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Header Background{" "}
                                    {/* <span className="text-danger font-size-16">
                                      *
                                    </span> */}
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        companyHeaderBackground.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="file"
                                      name={companyHeaderBackground.name}
                                      onChange={this.onHeaderUpload}
                                      placeholder="Upload Background"
                                      accept="image/png, image/jpg, image/jpeg"
                                    />
                                    {details ? (
                                      <a
                                        target="_blank"
                                        href={`${process.env.REACT_APP_BASE_URL}/company/header/${details.COMPANY_HEADER_BACKGROUND}`}
                                      >
                                        {details.COMPANY_HEADER_BACKGROUND}
                                      </a>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Facebook Page URL
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={facebookPageUrl.name}
                                      value={facebookPageUrl.value}
                                      onChange={this.onChange}
                                      placeholder="Facebook Profile Url"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Linkedin Profile URL
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={linkedinProfileUrl.name}
                                      value={linkedinProfileUrl.value}
                                      onChange={this.onChange}
                                      placeholder="Linkedin Profile URL"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Twitter URL{" "}
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className="form-control"
                                      type="text"
                                      name={twitterUrl.name}
                                      value={twitterUrl.value}
                                      onChange={this.onChange}
                                      placeholder="Twitter URL"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Company Size{" "}
                                    <span className="text-danger font-size-16">
                                      *
                                    </span>
                                  </label>
                                  <div className="form-group">
                                    <select
                                      className={
                                        companySize.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      name={companySize.name}
                                      value={companySize.value}
                                      onChange={this.onChange}
                                    // placeholder="Company Size"
                                    >
                                      <option value={''}> Select Company Size</option>
                                      <option value={'1-5'}> 1-5</option>
                                      <option value={'5-10'}> 5-10</option>
                                      <option value={'10-20'}> 10-20</option>
                                      <option value={'20-50'}> 20-50</option>
                                      <option value={'50-100'}> 50-100</option>
                                      <option value={'100-250'}> 100-250</option>
                                      <option value={'250-500'}> 250-500</option>
                                      <option value={'500+'}> 500+</option>



                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Founded (Year)
                                    {/* <span className="text-danger font-size-16">
                                      *
                                    </span> */}
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        founded.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={founded.name}
                                      value={founded.value}
                                      onChange={this.onChange}
                                      placeholder="Founded"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    Headquarters{" "}
                                    {/* <span className="text-danger font-size-16">
                                      *
                                    </span> */}
                                  </label>
                                  <div className="form-group">
                                    <input
                                      className={
                                        headquarters.error.length > 0
                                          ? "form-control is-invalid"
                                          : "form-control"
                                      }
                                      type="text"
                                      name={headquarters.name}
                                      value={headquarters.value}
                                      onChange={this.onChange}
                                      placeholder="Headquarters"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-12 column-lg-full">
                                <div className="input-box">
                                  <label className="label-text">
                                    About Company{" "}
                                  </label>
                                  <div className="form-group">
                                    <textarea
                                      className="form-control"
                                      name={aboutCompany.name}
                                      value={aboutCompany.value}
                                      onChange={this.onChange}
                                      placeholder="About Company"
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className="row sq-db2"><div className="col-lg-12 pl-4 sq-db2"><div className="btn-box mt-4 pl-1 sq-db2">
                                <button type="submit" className="theme-btn border-0">
                                  <i className="la la-plus sq-db2"></i> Save Changes
                                </button>
                              </div>
                              </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default withRouter(EditProfile);
